import React from 'react';

const SingleSubmitForm = ({ onSubmit, children, className = '' }) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(e);
  };

  return (
    <form onSubmit={handleSubmit} className={className}>
      {children}
    </form>
  );
};

export default SingleSubmitForm;